<template>
 	<div class="flex-colum h-100">
		<div class="d-flex justify-content-between bd-highlight mb-3">
			<div class="align-self-center mb-3" style="height: 30px;">
				<button type="button" class="btn btn-primary" @click="openAddArticleClassDialog">添加</button>
			</div>
			<div class="input-group align-self-center ms-auto p-2 bd-highlight" style="width: 25%;">
				<input type="text" id="class-keywords" class="form-control" v-model="keywords">
				<button class="btn btn-outline-secondary" type="button" @click="searchArticleClass">搜索</button>
			</div>
		</div>
		<div>
			<table class="table table-bordered table-striped table-sm member-list">
				<thead>
					<tr>
						<th scope="col">序号</th><th scope="col">标题</th><th scope="col">ID</th><th scope="col">状态</th><th scope="col">推荐</th><th scope="col">添加时间</th><th scope="col">操作</th>
					</tr>
				</thead>
				<tbody id="member-list">
					<tr v-for="(value, idx) in dataList" :key='idx'>
						<td>{{50 * (nowPage - 1) + idx + 1}}</td>
						<td>{{value.title}}</td>
						<td>{{value.id}}</td>
						<td>
							<div class="mb-1 form-check form-switch" style="padding-top: 5px;">
								<input class="form-check-input" :checked="value.show === 1" @change="updateLabel(value, 'show')" type="checkbox" role="switch"/>
							</div>
						</td>
						<td>
							<div class="mb-1 form-check form-switch" style="padding-top: 5px;">
								<input class="form-check-input" :checked="value.recommend === 1" @change="updateLabel(value, 'recommend')" type="checkbox" role="switch"/>
							</div>
						</td>
						<td>{{dateFtt('yyyy-MM-dd hh:mm', new Date(value.operateTime))}}</td>
						<td>
							<div class="flex-row flex-align-center">
								<img class="button-icon" src="/assets/ic_edit.png" @click="openEditArticleClassDialog(value.id)"/>
								<img class="button-icon img-margin" src="/assets/ic_trash.png" @click="deleteArticleClass(value.id, value.title)"/>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<Pagination :page='nowPage' :max='totalPage/50' @loadPage="loadArticleLabelList" />
		</div>
	</div>
	
	<AddArticleLabelDialog :show='showAddDialog' :label='editLabel' @cancel='showAddDialog = false' @confirm='editArticleLabel'/>
	<LoadingDialog :show='showLoadingDialog' />
</template>

<script lang="ts">
import { reactive, toRefs, defineComponent, nextTick, onMounted, ref, watch, computed } from 'vue';
import Pagination from '@/components/Pagination.vue';
import AddArticleLabelDialog from '@/modals/AddArticleLabelDialog.vue';
import LoadingDialog from '@/modals/LoadingDialog.vue';
import request from "@/global";
import { checkResponseDataAndAlert, dateFtt } from '@/common/util';

export default({
	components: { Pagination, AddArticleLabelDialog, LoadingDialog },
	setup() {
		const refData = reactive({
			showAddDialog: false,
			showLoadingDialog: false,
			keywords: "搜索",
			editLabel: {},
		});
		
		const totalPage = ref<number>(0);
		const nowPage = ref<number>(1);
		const dataList = ref<any[]>([]);
		
		//needed in case we switch in from another window
		onMounted(async () => {
		  await loadArticleLabelList(1);
		});
		
		// ========================文章标签========================
		// 添加标签
		const openAddArticleClassDialog = () => {
			refData.editLabel = { recommend: false, show: true };
			refData.showAddDialog = true;
		};
		
		// 编辑信息
		const openEditArticleClassDialog = async (card_no: string) => {
		    const errMsg = "查询标签信息失败";
			try {
				const data = (await request({url: `article/class/${card_no}`, get: true})).data;
		        if (checkResponseDataAndAlert(data, errMsg) && data.data) {
					data.data.show = (data.data.show === 1)
					data.data.recommend = (data.data.recommend === 1)
		            refData.editLabel = data.data;
					refData.showAddDialog = true;
		        }
			} catch (e) {
				console.log(e);
				checkResponseDataAndAlert({}, errMsg);
			}
		}
		
		// 编辑
		const editArticleLabel = async (postObj: any) =>  {
			console.log(postObj);
		    const errMsg = `操作失败`;		
		    if (!postObj.title || postObj.title.length < 1) {
		        alert("请填写标题");
		        return;
		    }
		
		    refData.showLoadingDialog = true;
			try {
				const data = (await request({url: `article/class/save`, data: postObj})).data;
				refData.showLoadingDialog = false;
		        if (checkResponseDataAndAlert(data, errMsg)) {
					refData.showAddDialog = false;
		            loadArticleLabelList(nowPage.value);
		        }
			} catch (e) {
				refData.showLoadingDialog = false;
				checkResponseDataAndAlert({}, errMsg);
			}
		}
		
		const updateLabel  = async (item: any, key: string) => {
			refData.showLoadingDialog = true;
			try {
				const postObj: any = {};
				postObj[`${key}`] = item[`${key}`] === 1 ? 0 : 1;
				const data = (await request({url: `article/class/update/${item.id}`, data: postObj})).data;
				refData.showLoadingDialog = false;
			    if (checkResponseDataAndAlert(data, "操作失败")) {
					item[`${key}`] = postObj[`${key}`];
			    } else {
					loadArticleLabelList(nowPage.value);
				}
			} catch (e) {
				refData.showLoadingDialog = false;
				checkResponseDataAndAlert({}, "操作失败");
			}
		}
		
		// 删除
		const deleteArticleClass = async (card_no: string, name: string) => {
			if (confirm(`确认删除 ${name} 吗？`)) {
				const errMsg = "删除标签失败";
				try {
					const data = (await request({url: `article/class/delete/${card_no}`, get: true})).data;
					if (checkResponseDataAndAlert(data, errMsg)) {
						alert("删除标签成功");
						loadArticleLabelList(nowPage.value);
					}
				} catch (e) {
					checkResponseDataAndAlert({}, errMsg);
				}
			}
		};
		
		// 搜索
		const searchArticleClassInner = async () => {
		    if (refData.keywords.length === 0) {
		        loadArticleLabelList(1);
		        return;
		    }
		
		    nowPage.value = 1;
		    const postObj = {"page" : 1, "size": 50, "content": refData.keywords, timestamp: Date.now() };
			try {
				const data = (await request({url: `article/class/search`, data: postObj})).data;
		        if (checkResponseDataAndAlert(data) && data.data) {
					dataList.value = data.data;
					totalPage.value = data.total;
				}
			} catch (e) {
				checkResponseDataAndAlert({});
			}
		}
			
		// 加载列表
		const  loadArticleLabelList = async (page: number) => {
		    if (page < 1) return;
		
			dataList.value = [];
		    nowPage.value = page;
			try {
				const data = (await request({url: `article/class/list/${page}/${50}?show=2`, get: true})).data;
				if (checkResponseDataAndAlert(data) && data.data) {
				    dataList.value = data.data;
					totalPage.value = data.total;
				}
			} catch (e) {
				checkResponseDataAndAlert({});
			}
		};
		
		const dataRef = toRefs(refData);
		return {
			dataList,
			nowPage,
			totalPage,
			
			dateFtt,
			editArticleLabel,
			loadArticleLabelList,
			openAddArticleClassDialog,
			openEditArticleClassDialog,
			deleteArticleClass,
			updateLabel,
			
			...dataRef
		};
	},
});
</script>

<style>
</style>
